var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTickTableProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_671_24093",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_671_24093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33981 10.5C7.23747 10.5 7.13702 10.4803 7.03846 10.4408C6.94021 10.4013 6.85567 10.3421 6.78482 10.2631L4.71838 8.20202C4.56881 8.04408 4.49607 7.8525 4.50016 7.62728C4.50394 7.40238 4.58062 7.21491 4.73019 7.06487C4.88763 6.90693 5.0805 6.82797 5.30879 6.82797C5.53708 6.82797 5.72601 6.90693 5.87559 7.06487L7.33981 8.53368L11.1184 4.73135C11.2759 4.58131 11.4669 4.50424 11.6914 4.50013C11.9156 4.49634 12.1064 4.57342 12.2638 4.73135C12.4213 4.88929 12.5 5.08276 12.5 5.31177C12.5 5.54078 12.4213 5.7303 12.2638 5.88034L7.89479 10.2631C7.82394 10.3421 7.7394 10.4013 7.64115 10.4408C7.54259 10.4803 7.44214 10.5 7.33981 10.5Z",
    fill: "#13ACAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickTableProducts);
export default __webpack_public_path__ + "static/media/tick-table-products.9bc24c9f52232484bc8da2a8ddfe7127.svg";
export { ForwardRef as ReactComponent };